import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentGettingStartedContentEffects } from './store/tellent-getting-started-content.effects';
import { TellentGettingStartedProgressEffects } from './store/tellent-getting-started-progress.effects';
import {
  TellentGettingStartedContentNamespace,
  TellentGettingStartedContentReducer,
  TellentGettingStartedProgressNamespace,
  TellentGettingStartedProgressReducer,
} from './store/tellent-getting-started.store';

const provideTellentGettingStartedState = [
  provideState(TellentGettingStartedProgressNamespace, TellentGettingStartedProgressReducer),
  provideState(TellentGettingStartedContentNamespace, TellentGettingStartedContentReducer),
];

const provideTellentGettingStartedEffects = [
  provideEffects(TellentGettingStartedContentEffects),
  provideEffects(TellentGettingStartedProgressEffects),
];

export const tellentGettingStartedData = [
  ...provideTellentGettingStartedState,
  provideTellentGettingStartedEffects,
];
